// Vote buttons on the cached public pages. The page can't know who is signed
// in, so it asks /me.json once and marks the cars already voted for and the
// visitor's own cars (no voting for yourself).
export type VoteResult = {
  ok?: boolean; counted?: boolean; votes?: number; note?: string | null; error?: string; login?: string
  order?: OrderRow[]
}
export type OrderRow = { id: number; votes: number }

export function markVoted(root: ParentNode, voted: number[], mine: number[] = []): void {
  root.querySelectorAll<HTMLButtonElement>('[data-vote]').forEach((button) => {
    const id = Number(button.dataset.vote)
    if (mine.includes(id)) setMine(button)
    else if (voted.includes(id)) setVoted(button)
  })
}

export function setVoted(button: HTMLButtonElement): void {
  button.disabled = true
  button.textContent = 'Voted'
  button.setAttribute('aria-pressed', 'true')
}

export function setMine(button: HTMLButtonElement): void {
  button.disabled = true
  button.textContent = 'Your car'
  button.title = "Makers can't vote for their own products."
}

// Reorders the running order in place from the server's fresh standings and
// rewrites each row's position and "N votes · +gap" (same as the partial).
export function applyOrder(root: ParentNode, order: OrderRow[]): void {
  const list = root.querySelector<HTMLOListElement>('[data-votes]')
  if (!list || order.length === 0) return
  const rows = new Map<number, HTMLLIElement>()
  list.querySelectorAll<HTMLLIElement>('[data-entry]').forEach((li) => rows.set(Number(li.dataset.entry), li))
  const leader = order[0].votes
  const placed: HTMLLIElement[] = []
  order.forEach((row, index) => {
    const li = rows.get(row.id)
    if (!li) return
    const pos = li.querySelector<HTMLElement>('.pos')
    if (pos) pos.textContent = String(index + 1)
    const gap = li.querySelector<HTMLElement>('.order-gap')
    if (gap) gap.textContent = `${row.votes} ${row.votes === 1 ? 'vote' : 'votes'}${index > 0 ? ` · +${leader - row.votes}` : ''}`
    placed.push(li)
  })
  // Rows the order doesn't know (DNS, DSQ) keep their place at the end.
  const rest = [...rows.values()].filter((li) => !placed.includes(li))
  list.append(...placed, ...rest)
}

export function loginUrl(login: string, here: string): string {
  return `${login}?return_to=${encodeURIComponent(here)}`
}

// "2d 04:12:09" until the chequered flag.
export function countdown(to: number, now: number): string {
  let s = Math.max(0, Math.floor((to - now) / 1000))
  const d = Math.floor(s / 86_400)
  s -= d * 86_400
  const pad = (n: number) => String(n).padStart(2, '0')
  const hms = `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`
  return d > 0 ? `${d}d ${hms}` : hms
}
